import { put, takeLatest } from "redux-saga/effects";
import { requestOutstandingBalanceList } from "services/acclgl/client-Statement/outstandingBalance";
import {
  fetchOutstandingBalanceListRequest,
  fetchOutstandingBalanceListSuccess,
  fetchOutstandingBalanceListFailure,
} from "redux/reducers/acclgl/clientStatement/outstandingBalance";
export function* watchOutstandingBalanceSaga() {
  yield takeLatest(
    fetchOutstandingBalanceListRequest,
    fetchOutstandingBalancelist
  );
}

function* fetchOutstandingBalancelist({ payload }) {
  try {
    const response = yield requestOutstandingBalanceList(payload);
    yield put(fetchOutstandingBalanceListSuccess(response));
  } catch (error) {
    yield put(
      fetchOutstandingBalanceListFailure(
        "Failed to get list of Outstanding Balance"
      )
    );
  }
}
